import { Component, ViewChild, OnInit } from '@angular/core';
import { DialogBoxComponent } from './dialog/dialog-box.component';
import { MatTable } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { first } from 'rxjs/operators';
import { EvaluacionService } from 'app/main/services/evaluacion.service';
import { Evaluacion } from 'app/main/models/evaluacion.model';
import { Objetivo } from 'app/main/models/objetivo.model';
import { Consolidacion } from 'app/main/models/consolidacion.model';
import { Router,ActivatedRoute } from '@angular/router';
import { FactorPonderacionService } from '../../services/factor-ponderacion.service';
import { EscenarioService } from 'app/main/services/escenario.service';
import { EstructuraJerarquicaService } from 'app/main/services/estructura-jerarquica.service';
import { UsersService } from 'app/main/services/users.service';
import { NodeSelectorDialogBoxComponent} from 'app/main/apps/estructura-jerarquica/dialog/node-selector-dialog-box.component';
import { Escenario } from 'app/main/models/escenario.model';
import {TranslateService} from '@ngx-translate/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import { getUsuariosNodo } from 'app/main/models/nodo-estructura-jerarquica.model';
import { PonderacionEvaluacion} from 'app/main/models//ponderacion-evaluacion.model';
import { PonderacionObjetivo} from 'app/main/models//ponderacion-objetivo.model';
import { TokenStorageService } from 'app/main/auth/token-storage.service';


@Component({
    selector   : 'consolidar-evaluacion',
    templateUrl: './consolidar-evaluacion.component.html',
    styleUrls  : ['./evaluacion.component.scss']
})
export class ConsolidarEvaluacionComponent
{
    factoresIncompletos:boolean = true;
    action: string;
    LOCAL_DATA: Consolidacion = new Consolidacion({});
    factoresPonderacion = [];
    estructuraJerarquicas = [];
    escenarios = [];
    evaluaciones = [];
    ponderaciones = [];
    nodosEstructuraJerarquica = [];
    usuarios = [];
    tiposPonderacion = ["EVALUACION","OBJETIVO"];
    evaluacionSelect: Evaluacion;

    displayedColumns: string[] = ['nombre','version','escenario','estructuraJerarquica','creador','dueno','fechaInicio','fechaFin','estado','action'];
    displayedColumnsPonderaciones: string[] = ['evaluacion','factorPonderacion','factor'];
    displayedColumnsPonderacionesObjetivos: string[] = ['evaluaciones','objetivo','factor'];


    constructor(public dialog: MatDialog,
                public serviceFactorEvaluacion:FactorPonderacionService,
                public service: EvaluacionService,
                private storage: TokenStorageService,
                public serviceEscenarios:EscenarioService,
                public serviceEstructuraJerarquica:EstructuraJerarquicaService,
                public userService: UsersService,
                private _snackBar: MatSnackBar,
                public router: Router,
                public translate: TranslateService,
                private route: ActivatedRoute) {}

    ngOnInit() {
      this.serviceFactorEvaluacion.getAll(0,1000).pipe().subscribe(req => {
        this.factoresPonderacion = req.body.map( tipo => {
          console.log(tipo);
          return {
            id: tipo.id,
            nombre: tipo.nombre,
            ponderaciones: tipo.ponderaciones
          };
        });
      });

      this.serviceEscenarios.getAll(0,1000).pipe().subscribe(req => {
        this.escenarios = req.body.map( tipo => {
          console.log(tipo);
          return {
            id: tipo.id,
            nombre: tipo.nombre,
            formulaDeExposicion: tipo.formulaDeExposicion,
            apetito:tipo.apetito,
            tolerancia: tipo.tolerancia
          };
        });
      });

      this.serviceEstructuraJerarquica.getAll(0,1000).pipe().subscribe(req => {
        this.estructuraJerarquicas = req.body.map( tipo => {
          console.log(tipo);
          return {
            id: tipo.id,
            nombre: tipo.nombre,
            nodos: tipo.nodos
          };
        });
      });

    }

    openDialog(): void {
      var user = this.storage.getUser();
      var obj = {usuario: user};
      const dialogRef = this.dialog.open(NodeSelectorDialogBoxComponent, {
        width: '100%',
        data: obj,
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {
        this.LOCAL_DATA.nodoEstructuraJerarquica = result.data.nodo;
        this.LOCAL_DATA.estructuraJerarquica = result.data.estructura;
        this.getEvaluaciones();
        this.usuarios = getUsuariosNodo(result.data.nodo);

      });
    }

    getEvaluaciones(){
      if(this.LOCAL_DATA.nodoEstructuraJerarquica!=null && this.LOCAL_DATA.fechaInicio!=null && this.LOCAL_DATA.fechaFin!=null)
        this.service.getByNodoBetweenDates(this.LOCAL_DATA.nodoEstructuraJerarquica.id,this.LOCAL_DATA.fechaInicio,
        this.LOCAL_DATA.fechaFin).pipe().subscribe(req => {
          this.evaluaciones = req.map( evaluacion => {
            console.log(evaluacion);
            return {
              id: evaluacion.id,
              nombre: evaluacion.nombre,
              version: evaluacion.version,
              estructuraJerarquica: evaluacion.estructuraJerarquica,
              fechaCreado: evaluacion.fechaCreado,
              nodoEstructuraJerarquica: evaluacion.nodoEstructuraJerarquica,
              escenario: evaluacion.escenario,
              owner: evaluacion.owner,
              fechaInicio: evaluacion.fechaInicio,
              fechaFin: evaluacion.fechaFin,
              estado: evaluacion.estado,
              tipo: evaluacion.tipo,
              creador: evaluacion.creador,
              objetivos: evaluacion.objetivos
            };
          });
          this.evaluaciones = [...this.evaluaciones];
        });
    }

    addEvaluacion():void{

      //this.LOCAL_DATA.evaluaciones = evalu;
      this.LOCAL_DATA.evaluaciones = [...this.LOCAL_DATA.evaluaciones];
      this.generarPonderaciones();

      this.LOCAL_DATA.evaluaciones = [...this.LOCAL_DATA.evaluaciones];
    }

    generarPonderaciones(){

      this.LOCAL_DATA.ponderacionesPorEvaluacion = [];
      this.LOCAL_DATA.ponderacionesPorObjetivo=[];
      var objetivosDiccId = {};
      var posicion = 0;
      this.LOCAL_DATA.evaluaciones.forEach((element:Evaluacion) => {
        var pEval = new PonderacionEvaluacion({});
        var evalIn = new Evaluacion({id:element.id,nombre:element.nombre});
        pEval.evaluacion = evalIn;
        this.LOCAL_DATA.ponderacionesPorEvaluacion.push(pEval);

        element.objetivos.forEach((obje:Objetivo) => {
          if(!(obje.id in objetivosDiccId)){
            var pObj = new PonderacionObjetivo({});
            pObj.evaluaciones.push(evalIn);
            pObj.objetivo = obje;
            this.LOCAL_DATA.ponderacionesPorObjetivo.push(pObj);
            objetivosDiccId[obje.id] = posicion++;
          }else{
            this.LOCAL_DATA.ponderacionesPorObjetivo[objetivosDiccId[obje.id]].evaluaciones.push(evalIn);
          }

        });
      });
    }

    validarPonderacionesPorEvaluacion():void{

      this.factoresIncompletos = false;

      this.LOCAL_DATA.ponderacionesPorEvaluacion.forEach(element => {
        if(element.factor==null)
          this.factoresIncompletos = true;
      });

    }

    validarPonderacionesPorObjetivo():void{

      this.factoresIncompletos = false;

      this.LOCAL_DATA.ponderacionesPorObjetivo.forEach(element => {
        if(element.factor==null)
          this.factoresIncompletos = true;
      });

    }

    removeEvaluacion(evalu):void{

      var indexEval = 0;
      var counter=0;
      this.LOCAL_DATA.evaluaciones.forEach(element => {
        if(element.id == evalu.id)
          indexEval = counter;
        counter+=1;
      });

      this.LOCAL_DATA.evaluaciones.splice(indexEval, 1);
      this.LOCAL_DATA.evaluaciones = [...this.LOCAL_DATA.evaluaciones];
    }

    addConsolidacion(): void {

      this.service.registerConsolidacion(this.LOCAL_DATA).pipe(first()).subscribe(
        evaluacion => {
          console.log(evaluacion);

          //this.navegateTo('/evaluacion',evaluacion.body.id);
          this.LOCAL_DATA = new Consolidacion({});
          this.openSnackBar("Se ha creado la consolidación correctamente.","Cerrar");
        },
        error => {
          console.log(error);
          this.openSnackBar("No se pudo crear la consolidación, ocurrió un error.","Cerrar");
        }
      );
    }

    navegateTo(url, id): void  {
        this.router.navigate([url, id]).then( (e) => {
          if (e) {
            console.log("Navigation is successful!");
          } else {
            console.log("Navigation has failed!");
          }
        });
    }

    openSnackBar(message: string, action: string) {
      this._snackBar.open(message, action, {
        duration: 5000,
      });
    }

    selectFactor():void{
      this.factoresIncompletos = true;
      this.ponderaciones = this.LOCAL_DATA.factorPonderacion.ponderaciones;
      this.ponderaciones = [...this.ponderaciones];
    }


    esOwnersGroup(usuario):boolean{

      var esOwner:boolean = false;

      usuario.tipos.forEach(element => {
        if(element.id == 4)
          esOwner = true;
      });

      return esOwner;
    }

}
